import React, { useEffect, useMemo, useState } from "react";
import Multiselect from "multiselect-react-dropdown";
import {
  Card,
  CardBody,
  Col,
  Form,
  Row,
  Input,
  Label,
  Button,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";

/* === APIs (same paths you already use) === */
import {
  CreateAccountSave,
  CreateAccountUpdate,
  Get_RoleList,
  _Get,
  _GetList,
  _PostSave,
  _GetByUrlOnly,
} from "../../import/ApiEndPoint/ApiCalling";

import {
  Assign_Role_To_SuperAdmin,
  SubscriptinPlanList,
  viewpincodedata,
  View_User_By_Id,
  Role_list_by_Master,
} from "../../import/ApiEndPoint/Api";

const CreateSuperAdmin = () => {
  const navigate = useNavigate();
  const Params = useParams(); // "0" => create, else update

  const [Mode, setMode] = useState("Create");
  const [Loading, setLoading] = useState(false);
  const [Loader, setLoader] = useState(false);

  const [BulkUpload, setBulkUpload] = useState(false);
  const [BulkImport, setBulkImport] = useState(null);

  const [subsList, setSubsList] = useState([]);
  const [allAssignableRoles, setAllAssignableRoles] = useState([]);
  const [selectedRolesToAssign, setSelectedRolesToAssign] = useState([]);
  const [dropdownRoles, setDropdownRoles] = useState([]);

  const [listItems, setListItems] = useState([]);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal((p) => !p);

  const [filters, setFilters] = useState({ state: "", district: "" });

  const handleFilterChange = (e) =>
    setFilters((p) => ({ ...p, [e.target.name]: e.target.value }));

  const filteredList = useMemo(() => {
    return (listItems || []).filter(
      (item) =>
        (item.state || "")
          .toLowerCase()
          .includes(filters.state.toLowerCase()) &&
        (item.district || "")
          .toLowerCase()
          .includes(filters.district.toLowerCase()),
    );
  }, [listItems, filters]);

  const [selectedAreas, setSelectedAreas] = useState([]);

  const isChecked = (item) =>
    selectedAreas.some((i) => String(i.pincode) === String(item.pincode));

  const handleCheckboxChange = (item) => {
    const exists = isChecked(item);

    setSelectedAreas((prev) =>
      exists
        ? prev.filter((i) => String(i.pincode) !== String(item.pincode))
        : [...prev, item],
    );
  };

  const handleSelectFiltered = () => {
    const toAdd = filteredList.filter((item) => !isChecked(item));
    setSelectedAreas((prev) => [...prev, ...toAdd]);
  };

  const [formData, setFormData] = useState({
    status: "Active",
    isHRM: false,
    rolename: "",
    position: "SuperAdmin",
    subscriptionPlan: "",
    database: "",
    email: "",
    password: "",
    companyName: "",
    ownerName: "",
    gstNumber: "",
    Pan_No: "",
    Aadhar_No: "",
    mobileNumber: "",
    pincode: "",
    City: "",
    State: "",
    Country: "",
    address1: "",
  });

  // --- inline CSS ---
  useEffect(() => {
    const id = "superadmin-inline-css";

    if (document.getElementById(id)) return;

    const s = document.createElement("style");
    s.id = id;

    s.textContent = `
      .sa { --fs:14px; --fs-lg:15px; --h:40px; --gap:8px; }
      .sa *{ font-size:var(--fs) !important; }
      .sa h1{ font-size:24px !important; font-weight:600; }
      .sa h2{ font-size:20px !important; font-weight:600; }
      .sa label{ font-size:13px !important; font-weight:600; margin-bottom:6px; }
      .sa input:not([type="radio"]):not([type="checkbox"]),
      .sa select,
      .sa textarea{ font-size:var(--fs-lg) !important; height:var(--h); padding:8px 10px; border-radius:10px; border:1px solid #d6d8e1; background:#fff; }
      .sa .btn{ border-radius:10px; padding:8px 14px; font-weight:500; }
      .sa .card-soft{ background:#f3f6ff; border:1px solid #e5e7ef; border-radius:12px; padding:12px; box-shadow: rgba(16, 24, 40, .04) 0 1px 2px; }
      .sa .form-group, .sa .cssforproductlist{ margin-bottom: var(--gap) !important; }
      .sa .row.g-tight{ row-gap: var(--gap); }
      .sa .myphoneinput{ height:var(--h) !important; font-size:var(--fs-lg) !important; padding:8px 10px !important; }
      .sa input[type="radio"]{ height:16px !important; width:16px !important; padding:0 !important; margin:0 6px 0 0 !important; accent-color:#2563eb; }
      .sa .radio-line{ display:flex; align-items:center; gap:18px; font-weight:600; }
      .sa .radio-line label{ display:flex; align-items:center; gap:8px; margin:0; font-weight:600; }
      .sa .multiselect-dropdown .searchBox,
      .sa .multiselect-dropdown .chip,
      .sa .multiselect-dropdown .option{ font-size:var(--fs-lg) !important; min-height:var(--h); }
    `;

    document.head.appendChild(s);
  }, []);

  // pincode data
  useEffect(() => {
    (async () => {
      try {
        const resPins = await _GetByUrlOnly(viewpincodedata);
        setListItems(resPins?.pinCodeList || []);
      } catch {}
    })();
  }, []);

  const extractRoles = (res) => {
    const roles =
      res?.Role ||
      res?.Roles ||
      res?.data?.Role ||
      res?.data?.Roles ||
      res?.data?.RoleList ||
      res?.role ||
      res?.roles ||
      [];

    return Array.isArray(roles) ? roles : [];
  };

  const loadRoles = async (user) => {
    try {
      if (user?.rolename?.roleName === "MASTER") {
        let res;

        try {
          res = await _Get(Role_list_by_Master, user?._id);
        } catch {
          res = await _GetByUrlOnly(
            `${String(Role_list_by_Master).replace(/\/+$/, "")}/${user?._id}`,
          );
        }

        const roles = extractRoles(res).filter(Boolean);

        const superAdmin = roles.find(
          (r) => (r?.roleName || "").toLowerCase() === "superadmin",
        );

        setDropdownRoles(superAdmin ? [superAdmin] : []);

        const assignable = roles.filter(
          (r) => (r?.roleName || "").toUpperCase() !== "MASTER",
        );

        setAllAssignableRoles(assignable);

        if (superAdmin) {
          setFormData((p) => ({
            ...p,
            rolename: superAdmin?._id,
            position: superAdmin?.roleName || "SuperAdmin",
          }));
        }
      } else {
        const res = await Get_RoleList(user?._id, user?.database);
        const roles = extractRoles(res).filter(Boolean);

        const superAdminOnly = roles.filter(
          (r) => (r?.roleName || "").toLowerCase() === "superadmin",
        );

        setDropdownRoles(superAdminOnly);

        const assignable = roles.filter(
          (r) => (r?.roleName || "").toUpperCase() !== "MASTER",
        );

        setAllAssignableRoles(assignable);

        if (superAdminOnly?.[0]) {
          setFormData((p) => ({
            ...p,
            rolename: superAdminOnly[0]?._id,
            position: superAdminOnly[0]?.roleName || "SuperAdmin",
          }));
        }
      }
    } catch (e) {
      console.error("[roles] load error:", e);
      setDropdownRoles([]);
      setAllAssignableRoles([]);
    }
  };

  // bootstrap
  useEffect(() => {
    (async () => {
      const user = JSON.parse(localStorage.getItem("userData"));

      _GetList(SubscriptinPlanList, user?.database)
        .then((res) => setSubsList(res?.Subscription || []))
        .catch(() => {});

      await loadRoles(user);

      if (String(Params?.id) === "0") {
        setMode("Create");

        if (user?.database) {
          setFormData((p) => ({ ...p, database: user?.database }));
        }
      } else {
        setMode("Update");

        try {
          let res;

          try {
            res = await _GetByUrlOnly(
              `${String(View_User_By_Id).replace(/\/+$/, "")}/${Params?.id}`,
            );
          } catch {
            res = await _Get(View_User_By_Id, Params?.id);
          }

          let U =
            res?.User ||
            res?.user ||
            res?.data?.User ||
            res?.data?.user ||
            res?.data ||
            res;

          if (Array.isArray(U)) U = U[0];

          if (!U) throw new Error("User not found");

          setFormData((p) => ({
            ...p,
            companyName: U?.companyName || "",
            gstNumber: U?.gstNumber || "",
            Pan_No: U?.Pan_No || "",
            Aadhar_No: U?.Aadhar_No || "",
            mobileNumber: U?.mobileNumber || "",
            ownerName: U?.ownerName || U?.firstName || "",
            email: U?.email || "",
            password: "",
            pincode: U?.pincode || "",
            City: U?.City || "",
            State: U?.State || "",
            Country: U?.Country || "",
            address1: U?.address1 || "",
            database: U?.database || user?.database || "",
            rolename: U?.rolename?._id || U?.rolename || "",
            position: U?.rolename?.roleName || U?.position || "SuperAdmin",
            subscriptionPlan: U?.subscriptionPlan || "",
            status: U?.status || "Active",
            isHRM: U?.isHRM === true || U?.isHRM === "true",
          }));
        } catch (e) {
          swal("Couldn't load user details");
        }
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Params?.id]);

  const setField = (name, value) =>
    setFormData((p) => ({ ...p, [name]: value }));

  const handleGSTChange = (v) => {
    const val = String(v || "")
      .toUpperCase()
      .replace(/\s/g, "");

    let pan = formData.Pan_No;

    if (val.length >= 12) {
      pan = val.slice(2, 12);
    }

    setFormData((p) => ({ ...p, gstNumber: val, Pan_No: pan }));
  };

  const handlePincodeChange = (val) => {
    const Selected = (listItems || []).find(
      (x) => String(x.pincode || x.Pincode) === String(val),
    );

    if (Selected) {
      setFormData((p) => ({
        ...p,
        pincode: val,
        City: Selected.city || Selected.District || "",
        State: Selected.state || Selected.StateName || "",
        Country: Selected.country || "India",
      }));
    } else {
      setFormData((p) => ({ ...p, pincode: val }));
    }
  };

  const onSelectRoles = (list) => setSelectedRolesToAssign(list);
  const onRemoveRoles = (list) => setSelectedRolesToAssign(list);

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      const fd = new FormData();

      let computedId = (formData.id || "").trim();

      if (!computedId) {
        const pan = (formData.Pan_No || "").toUpperCase();
        const mobile = String(formData.mobileNumber || "").replace(/\D/g, "");
        const namePart = String(formData.ownerName || "USER")
          .replace(/\s+/g, "")
          .toUpperCase();

        if (/^[A-Z]{5}\d{4}[A-Z]$/.test(pan)) {
          computedId = pan;
        } else if (mobile.length >= 4) {
          computedId = `${namePart}-${mobile.slice(-4)}`;
        } else {
          computedId = `${namePart}-${Date.now()
            .toString(36)
            .slice(-6)
            .toUpperCase()}`;
        }
      }

      fd.append("id", computedId);

      const fields = [
        "companyName",
        "gstNumber",
        "Pan_No",
        "Aadhar_No",
        "mobileNumber",
        "ownerName",
        "email",
        "password",
        "pincode",
        "City",
        "State",
        "Country",
        "isHRM",
        "address1",
        "database",
        "status",
        "subscriptionPlan",
      ];

      fields.forEach((k) => {
        const v = formData[k];

        if (v !== undefined && v !== null && v !== "") {
          fd.append(k, k === "isHRM" ? String(v) : v);
        }
      });

      if (formData.rolename) {
        fd.append("rolename", formData.rolename);
        fd.append("position", formData.position || "SuperAdmin");
      }

      if (selectedAreas.length) {
        fd.append("serviceArea", JSON.stringify(selectedAreas));
      }

      const isMaster =
        JSON.parse(localStorage.getItem("userData"))?.rolename?.roleName ===
        "MASTER";

      if (String(Params?.id) === "0") {
        const res = await CreateAccountSave(fd);

        if (res?.status) {
          if (isMaster && selectedRolesToAssign.length) {
            const AssignDataBase = selectedRolesToAssign.map((ele) => ({
              role: {
                roleName: ele?.roleName,
                position: 0,
                desc: ele?.desc,
                id: ele?.id,
                rank: 0,
                rolePermission: ele?.rolePermission,
                database: formData["database"],
                createdBy: userData?._id,
              },
            }));

            try {
              await _PostSave(Assign_Role_To_SuperAdmin, {
                Roles: JSON.stringify(AssignDataBase),
              });
            } catch {}
          }

          swal("SuperAdmin created successfully");
          return navigate(-1)();
        }

        swal(res?.message || "Create failed");
      } else {
        const res = await CreateAccountUpdate(Params?.id, fd);

        if (res?.status) {
          if (isMaster && selectedRolesToAssign.length) {
            const AssignDataBase = selectedRolesToAssign.map((ele) => ({
              role: {
                roleName: ele?.roleName,
                position: 0,
                desc: ele?.desc,
                id: ele?.id,
                rank: 0,
                rolePermission: ele?.rolePermission,
                database: formData["database"],
                createdBy: userData?._id,
              },
            }));

            try {
              await _PostSave(Assign_Role_To_SuperAdmin, {
                Roles: JSON.stringify(AssignDataBase),
              });
            } catch {}
          }

          swal("SuperAdmin updated successfully");
          return navigate(-1)();
        }

        swal(res?.message || "Update failed");
      }
    } catch (err) {
      swal(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
      setLoader(false);
    }
  };

  return (
    <div className="sa">
      <Card className="card-soft" style={{ padding: 12 }}>
        <Row className="align-items-center mb-2">
          <Col />

          <Col className="text-center">
            <h1 className="m-0">{Mode} SuperAdmin</h1>
          </Col>

          <Col
            className="d-flex justify-content-end gap-1"
            lg="4"
            md="5"
            sm="12"
          >
            {!BulkUpload ? (
              <>
                <Button color="primary" onClick={() => setBulkUpload(true)}>
                  Bulk Upload
                </Button>

                <Button color="secondary" onClick={() => navigate(-1)()}>
                  Back
                </Button>
              </>
            ) : (
              <Button color="primary" onClick={() => setBulkUpload(false)}>
                Back
              </Button>
            )}
          </Col>
        </Row>

        <Form onSubmit={submitHandler}>
          {BulkUpload ? (
            <>{/* bulk upload UI kept as-is */}</>
          ) : (
            <>
              <Row className="g-3 g-tight">
                {/* LEFT COLUMN */}
                <Col lg="6" md="12">
                  <CardBody className="card-soft">
                    <div className="d-flex justify-content-center mb-1">
                      <h1>Personal Information</h1>
                    </div>

                    <Row className="g-tight">
                      <Col lg="6" md="6" sm="12">
                        <Label>Company Name *</Label>
                        <Input
                          required
                          placeholder="Enter Company Name"
                          value={formData.companyName}
                          onChange={(e) =>
                            setField("companyName", e.target.value)
                          }
                        />
                      </Col>

                      <Col lg="6" md="6" sm="12">
                        <Label>GST Number *</Label>
                        <Input
                          required
                          placeholder="Enter GST Number"
                          value={formData.gstNumber}
                          onChange={(e) => handleGSTChange(e.target.value)}
                        />
                      </Col>

                      <Col lg="6" md="6" sm="12">
                        <Label>PAN Number *</Label>
                        <Input
                          required
                          placeholder="Enter PAN Number"
                          value={formData.Pan_No}
                          onChange={(e) =>
                            setField("Pan_No", e.target.value.toUpperCase())
                          }
                        />
                      </Col>

                      <Col lg="6" md="6" sm="12">
                        <Label>Aadhar Number</Label>
                        <Input
                          placeholder="Enter Aadhar Number"
                          value={formData.Aadhar_No}
                          onChange={(e) =>
                            setField("Aadhar_No", e.target.value)
                          }
                        />
                      </Col>

                      <Col lg="6" md="6" sm="12">
                        <Label>Mobile Number</Label>
                        <PhoneInput
                          inputClass="myphoneinput"
                          country="in"
                          countryCodeEditable={false}
                          value={formData.mobileNumber}
                          onChange={(val) => setField("mobileNumber", val)}
                        />
                      </Col>

                      <Col lg="6" md="6" sm="12">
                        <Label>Owner Name *</Label>
                        <Input
                          required
                          placeholder="Enter First Name"
                          value={formData.ownerName}
                          onChange={(e) =>
                            setField("ownerName", e.target.value)
                          }
                        />
                      </Col>

                      <Col lg="6" md="6" sm="12">
                        <Label>Email *</Label>
                        <Input
                          required
                          type="email"
                          placeholder="Enter Email"
                          value={formData.email}
                          onChange={(e) => setField("email", e.target.value)}
                        />
                      </Col>

                      <Col lg="6" md="6" sm="12">
                        <Label>Password *</Label>
                        <Input
                          required={String(Params?.id) === "0"}
                          type="password"
                          placeholder="Enter Password here"
                          value={formData.password}
                          onChange={(e) => setField("password", e.target.value)}
                        />
                      </Col>

                      <Col lg="6" md="6" sm="12">
                        <Label>Pin Code Number *</Label>
                        <Input
                          required
                          type="number"
                          placeholder="Enter Pin Code here"
                          value={formData.pincode}
                          onChange={(e) => handlePincodeChange(e.target.value)}
                        />
                      </Col>

                      <Col lg="6" md="6" sm="12">
                        <Label>City</Label>
                        <Input readOnly value={formData.City} />
                      </Col>

                      <Col lg="6" md="6" sm="12">
                        <Label>State</Label>
                        <Input readOnly value={formData.State} />
                      </Col>

                      <Col lg="6" md="6" sm="12">
                        <Label>Country</Label>
                        <Input readOnly value={formData.Country} />
                      </Col>
                    </Row>
                  </CardBody>
                </Col>

                {/* RIGHT COLUMN */}
                <Col lg="6" md="12">
                  <CardBody className="card-soft">
                    <div className="d-flex justify-content-center mb-1">
                      <h1>Official information</h1>
                    </div>

                    <Row className="g-tight">
                      <Col lg="12" md="12" sm="12">
                        <Label>Select Role *</Label>
                        <Input
                          required
                          type="select"
                          value={formData.rolename}
                          onChange={(e) => {
                            const option =
                              e.target.options[e.target.selectedIndex];

                            const roleName =
                              option.getAttribute("data-rolename");

                            setFormData((p) => ({
                              ...p,
                              rolename: e.target.value,
                              position: roleName || "SuperAdmin",
                            }));
                          }}
                        >
                          <option value="">Select</option>

                          {(dropdownRoles || []).map((r) => (
                            <option
                              key={r?._id}
                              value={r?._id}
                              data-rolename={r?.roleName}
                            >
                              {r?.roleName}
                            </option>
                          ))}
                        </Input>
                      </Col>

                      <Col lg="12" md="12" sm="12">
                        <Label>Select Roles to Assign *</Label>
                        <Multiselect
                          className="w-100"
                          showCheckbox
                          isObject
                          options={allAssignableRoles}
                          selectedValues={selectedRolesToAssign}
                          displayValue="roleName"
                          onSelect={onSelectRoles}
                          onRemove={onRemoveRoles}
                          placeholder="Select"
                        />
                      </Col>

                      <Col lg="12" md="12" sm="12">
                        <Label>Plan Name *</Label>
                        <Input
                          required
                          type="select"
                          value={formData?.subscriptionPlan || ""}
                          onChange={(e) =>
                            setField("subscriptionPlan", e.target.value)
                          }
                        >
                          <option value="">----select Plan----</option>

                          {(subsList || []).map((s) => (
                            <option key={s?._id} value={s?._id}>
                              {s?.planName} (Price {s?.subscriptionCost}) (
                              {s?.subscriptionType === 1
                                ? "Yearly"
                                : "One Time"}
                              )
                            </option>
                          ))}
                        </Input>
                      </Col>

                      <Col lg="12" md="12" sm="12">
                        <Label>Database Name *</Label>
                        <Input
                          required
                          placeholder="one or two or three ..."
                          value={formData.database}
                          onChange={(e) => setField("database", e.target.value)}
                        />
                      </Col>

                      <Col lg="12" md="12" sm="12">
                        <Label>Address</Label>
                        <Input
                          placeholder="address name"
                          value={formData.address1}
                          onChange={(e) => setField("address1", e.target.value)}
                        />
                      </Col>

                      <Col lg="12" md="12" sm="12" className="mt-1">
                        <Label className="mb-1">Status</Label>

                        <div className="radio-line">
                          <label>
                            <Input
                              type="radio"
                              name="status"
                              checked={formData?.status === "Active"}
                              onChange={() => setField("status", "Active")}
                            />
                            <span>Active</span>
                          </label>

                          <label>
                            <Input
                              type="radio"
                              name="status"
                              checked={formData?.status === "Deactive"}
                              onChange={() => setField("status", "Deactive")}
                            />
                            <span>Deactive</span>
                          </label>

                          <label>
                            <Input
                              type="checkbox"
                              checked={!!formData?.isHRM}
                              onChange={(e) =>
                                setField("isHRM", e.target.checked)
                              }
                            />
                            <span>HRM only</span>
                          </label>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Col>
              </Row>

              {Loader ? (
                <Row className="mt-2">
                  <Col className="d-flex justify-content-center">
                    <Spinner>Loading...</Spinner>
                  </Col>
                </Row>
              ) : (
                <Row className="mt-2">
                  <Col className="d-flex justify-content-center">
                    <Button color="primary" type="submit" disabled={Loading}>
                      {Loading ? "Please wait..." : Mode}
                    </Button>
                  </Col>
                </Row>
              )}
            </>
          )}
        </Form>
      </Card>

      {/* Address selection modal */}
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Select Address</ModalHeader>

        <ModalBody>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex gap-2 flex-wrap">
              <Input
                type="text"
                name="state"
                value={filters.state}
                placeholder="Filter by State"
                onChange={handleFilterChange}
              />

              <Input
                type="text"
                name="district"
                value={filters.district}
                placeholder="Filter by District"
                onChange={handleFilterChange}
              />
            </div>

            <Button color="primary" onClick={handleSelectFiltered}>
              Select All Filtered
            </Button>
          </div>

          <Table bordered responsive hover className="align-middle">
            <thead className="table-light">
              <tr>
                <th className="text-center" style={{ width: 80 }}>
                  Select
                </th>
                <th>State</th>
                <th>District</th>
                <th>City</th>
                <th>Pincode</th>
              </tr>
            </thead>

            <tbody>
              {filteredList.map((item, index) => (
                <tr key={`${item?.pincode}-${index}`}>
                  <td className="text-center">
                    <Input
                      type="checkbox"
                      className="form-check-input m-0"
                      style={{ transform: "scale(1.1)" }}
                      checked={isChecked(item)}
                      onChange={() => handleCheckboxChange(item)}
                    />
                  </td>

                  <td>{item.state}</td>
                  <td>{item.district}</td>
                  <td>{item.city}</td>
                  <td>{item.pincode}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CreateSuperAdmin;
